const config = {
  API_URL: 'https://backend-platzi-badges.herokuapp.com'
};

module.exports = { config };